/**
 * Normalises a string for diacritic-insensitive, case-insensitive matching.
 * NFD strips combining diacritics (e.g. ü → u) but does NOT handle the Turkish
 * dotless ı (U+0131) or dotted capital İ (U+0130), so those are replaced
 * explicitly. Note that NFD decomposes İ (U+0130) into I + combining dot
 * (U+0049 U+0307), so the combining dot must be stripped before/alongside the
 * explicit replacements.
 */
export const normaliseForComparison = (s: string) =>
  s
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\u0130/g, 'i') // Turkish dotted capital İ
    .replace(/\u0131/g, 'i') // Turkish dotless ı
    .toLowerCase()
